import { selectors } from './initialization.js';

export const AUTOCOMPLETE_TEMPLATE = `
  {{#gt suggestions.length 0}}
    <ul class="suggestions">
      {{#each ../suggestions}}
        <li data-keyword="{{value}}" tabindex="0" data-index="{{@index}}" class="suggestion{{#equals ../../activeSuggestionIndex @index}} active{{/equals}}">
          {{{getSuggestionHTML value}}}
        </li>
      {{/each}}
    </ul>
  {{/gt}}
`;

export const toggleAutocomplete = (searchEl) => {
	const autocomplete = searchEl.querySelector(selectors.searchAutocomplete);
	const offset = parseInt(autocomplete.getAttribute('data-delay'));
	const inputLength = searchEl.querySelector(selectors.searchInput).value.length;
	inputLength > offset ? (autocomplete.style.display = 'block') : (autocomplete.style.display = 'none');
};
